import SchedulingBlackouts from "./SchedulingBlackouts";
import SchedulingBookings from "./SchedulingBookings";
import SchedulingClasses from "./SchedulingClasses";
import SchedulingFacilities from "./SchedulingFacilities";
import SchedulingHistory from "./SchedulingHistory";
import SchedulingOverviewCalendar from "./SchedulingOverviewCalendar";
import SchedulingPtSessions from "./SchedulingPtSessions";
import SchedulingSettings from "./SchedulingSettings";
import SchedulingTours from "./SchedulingTours";

const SCHEDULING_TABS = [
  {
    id: "overview",
    label: "Overview",
    href: "/coaching-portal/scheduling",
    iconSrc: "/img/new-icons/vuesax-linear-calendar-schedule.svg",
  },
  {
    id: "classes",
    label: "Classes",
    href: "/coaching-portal/scheduling?tab=classes",
    iconSrc: "/img/new-icons/classes-icon.svg",
  },
  {
    id: "pt-sessions",
    label: "PT Sessions",
    href: "/coaching-portal/scheduling?tab=pt-sessions",
    iconSrc: "/img/new-icons/pt-session-icon.svg",
  },
  {
    id: "facilities",
    label: "Facilities",
    href: "/coaching-portal/scheduling?tab=facilities",
    iconSrc: "/img/new-icons/facilities-icon.svg",
  },
  {
    id: "consults",
    label: "Consults",
    href: "/coaching-portal/scheduling?tab=consults",
    iconSrc: "/img/new-icons/person-walking-solid.svg",
  },
  {
    id: "bookings",
    label: "Bookings",
    href: "/coaching-portal/scheduling?tab=bookings",
    iconSrc: "/img/new-icons/scheduling-calendar-icon.svg",
  },
  {
    id: "history",
    label: "History",
    href: "/coaching-portal/scheduling?tab=history",
    iconSrc: "/img/new-icons/history-icon.svg",
  },
  {
    id: "blackouts",
    label: "Blackouts",
    href: "/coaching-portal/scheduling?tab=blackouts",
    iconSrc: "/img/new-icons/slash.svg",
  },
  {
    id: "settings",
    label: "Settings",
    href: "/coaching-portal/scheduling?tab=settings",
    iconSrc: "/img/new-icons/vuesax-linear-setting-2.svg",
  },
];

const Scheduling = ({
  tab = "overview",
  preview,
  previewId,
  hasNonPullScheduling = false,
  hasPressScheduling = false,
  hasPullScheduling = false,
  canPushUser = true,
  canPullUser = true,
}) => {
  const accessPerms = {
    hasPressScheduling,
    hasPullScheduling,
    canPushUser,
    canPullUser,
  };
  // Facilities are a PRESS/PERFORM feature, gated on PRESS/PERFORM scheduling
  // being enabled (not just owning the tier). When only PULL scheduling is on,
  // the tab is hidden and a direct ?tab=facilities link falls back to overview.
  const visibleTabs = hasNonPullScheduling
    ? SCHEDULING_TABS
    : SCHEDULING_TABS.filter(({ id }) => id !== "facilities");
  const effectiveTab =
    tab === "facilities" && !hasNonPullScheduling ? "overview" : tab;
  const isOverview = !effectiveTab || effectiveTab === "overview";
  return (
    <main className="scheduling" aria-label="Scheduling">
      <section className="scheduling-layout">
        <nav className="scheduling-sidebar" aria-label="Scheduling sections">
          <ul>
            {visibleTabs.map(({ id, label, href, iconSrc }) => {
              const isActive =
                (id === "overview" && !effectiveTab) ||
                (id === "overview" && effectiveTab === "overview") ||
                (id === "classes" && effectiveTab === "classes") ||
                (id === "pt-sessions" && effectiveTab === "pt-sessions") ||
                (id === "facilities" && effectiveTab === "facilities") ||
                (id === "consults" && effectiveTab === "consults") ||
                (id === "blackouts" && effectiveTab === "blackouts") ||
                (id === "bookings" && effectiveTab === "bookings") ||
                (id === "history" && effectiveTab === "history") ||
                (id === "settings" && effectiveTab === "settings");
              return (
                <li key={id} className={isActive ? "active" : undefined}>
                  <a href={href} aria-current={isActive ? "page" : undefined}>
                    <span
                      className={`scheduling-tab-icon${isActive ? " scheduling-tab-icon--active" : ""}`}
                      style={
                        isActive
                          ? {
                              WebkitMaskImage: `url(${iconSrc})`,
                              maskImage: `url(${iconSrc})`,
                            }
                          : undefined
                      }
                    >
                      <img src={iconSrc} alt="" />
                    </span>
                    <span>{label}</span>
                  </a>
                </li>
              );
            })}
          </ul>
          {isOverview && (
            <div
              id="scheduling-overview-filters-slot"
              className="scheduling-sidebar-filters"
            />
          )}
        </nav>
        <section className="scheduling-content">
          {effectiveTab === "settings" ? (
            <SchedulingSettings />
          ) : effectiveTab === "classes" ? (
            <SchedulingClasses
              hasNonPullScheduling={hasNonPullScheduling}
              {...accessPerms}
            />
          ) : effectiveTab === "pt-sessions" ? (
            <SchedulingPtSessions
              hasNonPullScheduling={hasNonPullScheduling}
              {...accessPerms}
            />
          ) : effectiveTab === "facilities" ? (
            <SchedulingFacilities hasPressScheduling={hasPressScheduling} />
          ) : effectiveTab === "consults" ? (
            <SchedulingTours />
          ) : effectiveTab === "blackouts" ? (
            <SchedulingBlackouts hasNonPullScheduling={hasNonPullScheduling} />
          ) : effectiveTab === "bookings" ? (
            <SchedulingBookings hasNonPullScheduling={hasNonPullScheduling} />
          ) : effectiveTab === "history" ? (
            <SchedulingHistory hasNonPullScheduling={hasNonPullScheduling} />
          ) : (
            <SchedulingOverviewCalendar
              preview={preview}
              previewId={previewId}
              hasNonPullScheduling={hasNonPullScheduling}
              {...accessPerms}
            />
          )}
        </section>
      </section>
    </main>
  );
};

export default Scheduling;
